(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-featured-testimonial"] && !Shopify.designMode) return;
  try {
    
  $('.slider_wrap').slick({
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instragram"] && !Shopify.designMode) return;
  try {
    
    $('.slider_instragram').slick({
      infinite: true,
      centerMode: true,
      centerPadding: '60px',
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1
        }
      }
    ]
    });
  
  } catch(e) { console.error(e); }
})();
})();
